<template>
  <BidForm />
  <HeaderBlock />
  <MainBlock />
  <WorksBlock />
  <CatalogBlock />
  <!-- <ProjectsSlider /> -->
  <UniqueBlock />
  <div class="block_for_glow">
    <div class="block_glow_v2"></div>
    <CalculatorBlock />
    <StandardsBlock />
    <!-- <ReviewsBlock /> -->
  </div>
  <QuestionsBlock />
  <CallBlock />
  <FooterBlock />
</template>

<script>
import HeaderBlock from "./components/HeaderBlock.vue";
import MainBlock from "./components/MainBlock.vue";
import WorksBlock from "./components/WorksBlock.vue";
// import ProjectsSlider from "./components/ProjectsSlider.vue";
import BidForm from "./components/ui/BidForm.vue";
import UniqueBlock from "./components/UniqueBlock.vue";
import CalculatorBlock from "./components/CalculatorBlock.vue";
import StandardsBlock from "./components/StandardsBlock.vue";
// import ReviewsBlock from "./components/ReviewsBlock.vue";
import QuestionsBlock from "./components/QuestionsBlock.vue";
import CallBlock from "./components/CallBlock.vue";
import FooterBlock from "./components/FooterBlock.vue";
import CatalogBlock from "./components/CatalogBlock.vue";

export default {
  name: "App",
  components: {
    HeaderBlock,
    MainBlock,
    WorksBlock,
    // ProjectsSlider,
    BidForm,
    UniqueBlock,
    CalculatorBlock,
    StandardsBlock,
    // ReviewsBlock,
    QuestionsBlock,
    CallBlock,
    FooterBlock,
    CatalogBlock,
  },
};
</script>

<style>
@import "@/assets/css/reset.css";
.block_for_glow {
  position: relative;
  overflow: hidden;
}
.block_glow_v2 {
  width: 118.16rem;
  height: 54.43rem;
  filter: blur(40rem);
  background: rgb(245, 160, 62);
  opacity: 0.2;
  position: absolute;
  right: -70rem;
  top: -15.5rem;
  z-index: -3;
}
@media (max-width: 767px) {
  .block_glow_v2 {
    width: 69.14rem;
    height: 69.14rem;
    left: 7.71rem;
    top: 6.2rem;
  }
}
</style>
